import React from 'react';
import {
  Box,
  Typography,
  Alert,
  Paper
} from '@mui/material';
import { useTranslation } from 'react-i18next';

// Импорт существующего компонента
import { RegistrationTokensList } from '../../../components/registration/RegistrationTokensList';

interface RegistrationTokensTabProps {
  // Пока без пропов
}

export const RegistrationTokensTab: React.FC<RegistrationTokensTabProps> = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 3 }}>
      {/* Заголовок */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" gutterBottom>
          {t('devices.management.tabs.registrationTokens')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t('devices.management.registrationTokensDescription')}
        </Typography>

        {/* Информационное сообщение */}
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            {t('devices.management.registrationTokensInfo')}
          </Typography>
        </Alert>
      </Box>

      {/* Компонент списка токенов регистрации */}
      <Paper elevation={1} sx={{ p: 0, overflow: 'hidden' }}>
        <RegistrationTokensList />
      </Paper>
    </Box>
  );
}; 